import React from "react";
import _ from "lodash";
import { Box } from "@mui/material";
import {
  MyHrAddUserRole,
  MyHrDataCollapse,
  MyHrRoleCollapse,
} from "my-hr/components";
import { OcCard, OcErrorBoundary } from "oc/components";

type MyHrAddRoleProps = {
  employee: any; // Replace 'any' with the correct type if available
  contractsData: any[]; // Replace 'any' with the correct type if available
  user: any; // Replace 'any' with the correct type if available
  setUser: (user: any) => void; // Replace 'any' with the correct type if available
  unsavedRole: any; // Replace 'any' with the correct type if available
  showUnsavedRole: boolean;
  onAddUnsavedRole: () => void;
  onRemoveUnsavedRole: () => void;
  loading: boolean;
  isMobile: boolean;
};

export const MyHrAddRole: React.FC<MyHrAddRoleProps> = ({
  employee,
  contractsData,
  user,
  setUser,
  unsavedRole,
  showUnsavedRole,
  onAddUnsavedRole,
  onRemoveUnsavedRole,
  loading,
  isMobile,
}) => {
  const handleAddRole = ({
    contract,
    module,
    role,
  }: {
    contract: string;
    module: string;
    role: string;
  }) => {
    try {
      let existingRoles = _.cloneDeep(user?.roles);
      let newRole = {
        contract: contract,
        product: module,
        role: role,
        roleFilters: {
          company: [],
          orgUnit: [],
          workingPlace: [],
          jobClassGroup: [],
          payOffice: [],
          contract: [],
        },
      };

      existingRoles.unshift(newRole);
      setUser({ roles: existingRoles });
    } catch (error) {
      console.log("error in add-role handler", error);
    }
  };

  const handleUpdateRole = (state: {
    contract?: string;
    product?: string;
    role?: string;
    roleFilters?: {
      company?: any[];
      orgUnit?: any[];
      workingPlace?: any[];
      jobClassGroup?: any[];
      payOffice?: any[];
      contract?: any[];
    };
    [key: string]: any;
  }) => {
    let newRoles = [...(user?.roles || [])];
    const elementIndex = newRoles.findIndex(
      (element) =>
        element.contract === state.contract &&
        element.role === state.role &&
        element.product === state.product,
    );

    newRoles[elementIndex] = state;
    let newUser = _.cloneDeep(user);
    newUser.roles = newRoles;
    setUser(newUser);
  };

  const handleRemoveRole = (role: {
    contract?: string;
    product?: string;
    role?: string;
    [key: string]: any;
  }) => {
    let newRoles = [...(user?.roles || [])];
    _.remove(newRoles, (element) => {
      return (
        element.contract === role.contract &&
        element.role === role.role &&
        element.product === role.product
      );
    });
    let newUser = _.cloneDeep(user);
    newUser.roles = newRoles;
    setUser(newUser);
  };

  return (
    <OcErrorBoundary>
      <Box>
        <MyHrDataCollapse
          id="addRoleUserDataCollapse"
          employee={employee}
          contractsData={contractsData}
          isMobile={isMobile}
        />
        {contractsData?.map((contract, index) => {
          let contractIndex = index;
          let jobClassName =
            contract?.jobClass?.name.charAt(0).toUpperCase() +
              contract?.jobClass?.name.slice(1) || "";

          if (user?.roles?.length === 0) {
            setUser({
              roles: [
                {
                  contract: contract?.code,
                  product: "MyHR",
                  role: "user",
                  roleFilters: {
                    company: [],
                    orgUnit: [],
                    workingPlace: [],
                    jobClassGroup: [],
                    payOffice: [],
                    contract: [],
                  },
                },
              ],
            });
          }
          return (
            <Box key={contract.code}>
              <OcCard
                label={`${jobClassName} - ${contract.code}`}
                loading={loading}
              >
                <Box>
                  <MyHrAddUserRole
                    roles={user?.roles || []}
                    contract={contract}
                    onAddRole={handleAddRole}
                    isMobile={isMobile}
                  />
                  {user?.roles?.map((role: any, index: number) => {
                    if (role.contract !== contract.code) return null;
                    return (
                      <Box
                        key={`${role?.contract}-${role?.product}-${role?.role}-${index}`}
                        marginBottom="16px"
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                      >
                        <MyHrRoleCollapse
                          role={role}
                          roleIndex={index}
                          index={contractIndex}
                          onUpdateRole={handleUpdateRole}
                          onRemoveRole={handleRemoveRole}
                          unsavedRole={unsavedRole}
                          onAddUnsavedRole={onAddUnsavedRole}
                          onRemoveUnsavedRole={onRemoveUnsavedRole}
                          showUnsavedRole={showUnsavedRole}
                          needToSave={false}
                          skipInitTempState={false}
                          product={role.product}
                        />
                      </Box>
                    );
                  })}
                </Box>
              </OcCard>
              <Box height="20px" />
            </Box>
          );
        })}
      </Box>
    </OcErrorBoundary>
  );
};

export default MyHrAddRole;
